import { configQuery, getLanguageTagBCP47, magicConfig, getLanguageIso6391, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_COUNTRY_QUERY, LANGUAGE_UPDATED, TRANSLATIONS_QUERY } from '@gig/magic-messages';
import { ListenMessageType } from '@gig/magic-galleon';

var CashierMixin = /** @class */ (function (_super) {
    __extends(CashierMixin, _super);
    function CashierMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userCountry = null;
        _this.userProfile = null;
        _this.tokenInterval = undefined;
        _this.languageSubscription = undefined;
        return _this;
    }
    CashierMixin.prototype.initiateWalletConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var initEvent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInitEvent()];
                    case 1:
                        initEvent = _a.sent();
                        this.dispatchEvent(ListenMessageType.InitGateways, initEvent);
                        this.tokenInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                            var event;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getUpdateConfigEvent()];
                                    case 1:
                                        event = _a.sent();
                                        this.dispatchEvent(ListenMessageType.UpdateGateways, event);
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1000 * 60);
                        return [2 /*return*/];
                }
            });
        });
    };
    CashierMixin.prototype.getUpdateConfigEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magic.session.getAccessToken()];
                    case 1:
                        token = _a.sent();
                        return [2 /*return*/, {
                                corex: {
                                    token: token,
                                },
                            }];
                }
            });
        });
    };
    CashierMixin.prototype.getInitEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var galleonConfiguration, _a, userData, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            configQuery('galleon'),
                        ])];
                    case 1:
                        galleonConfiguration = (_b.sent())[0];
                        if (!galleonConfiguration) {
                            return [2 /*return*/, Promise.reject(new Error('galleonConfiguration is undefined'))];
                        }
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_COUNTRY_QUERY)];
                    case 2:
                        _a.userCountry = _b.sent();
                        return [4 /*yield*/, window.queryBus.query('user:query')];
                    case 3:
                        userData = _b.sent();
                        return [4 /*yield*/, magic.session.getAccessToken()];
                    case 4:
                        token = _b.sent();
                        galleonConfiguration.userProfileId = userData.userId;
                        galleonConfiguration.userEmail = userData.email;
                        galleonConfiguration.token = token;
                        return [2 /*return*/, {
                                corex: galleonConfiguration,
                            }];
                }
            });
        });
    };
    CashierMixin.prototype.dispatchEvent = function (name, detail) {
        console.warn('dispatchEvent should be overridden in the component', name, detail);
    };
    CashierMixin.prototype.initiateWalletTranslations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var translationEvent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTranslationEvent()];
                    case 1:
                        translationEvent = _a.sent();
                        this.dispatchEvent(ListenMessageType.UpdateTranslations, translationEvent);
                        this.languageSubscription = window.eventBus.subscribe(LANGUAGE_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
                            var translationEvent;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getTranslationEvent()];
                                    case 1:
                                        translationEvent = _a.sent();
                                        this.dispatchEvent(ListenMessageType.UpdateTranslations, translationEvent);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    CashierMixin.prototype.getTranslationEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var translations, language;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(TRANSLATIONS_QUERY)];
                    case 1:
                        translations = _a.sent();
                        language = getLanguageTagBCP47(magicConfig.language);
                        return [2 /*return*/, {
                                translations: translations,
                                locale: language,
                                paysafeLocale: this.getLocale(),
                            }];
                }
            });
        });
    };
    CashierMixin.prototype.getLocale = function () {
        var _a;
        var language = getLanguageIso6391(magicConfig.language);
        var langLocale = getLanguageTagBCP47(magicConfig.language);
        var isLocaleCorrect = ((_a = langLocale === null || langLocale === void 0 ? void 0 : langLocale.split('-')) === null || _a === void 0 ? void 0 : _a.length) === 2;
        if (isLocaleCorrect) {
            return langLocale;
        }
        // create user locale from user profile data using country
        return language.toLowerCase() + "-" + this.userCountry.toUpperCase();
    };
    CashierMixin = __decorate([
        Component({
            name: 'wallet-init-mixin',
        })
    ], CashierMixin);
    return CashierMixin;
}(Mixins(MagicConfigMixin)));

export default CashierMixin;
